// horsepower leaderboards Section
//
//
document.addEventListener('DOMContentLoaded', function() {
  const tierFilter = document.getElementById('tier-filter');
  const leaderboardTiers = document.querySelectorAll('.leaderboard-tier');
  const imageContainers = document.querySelectorAll('.member-images img');

  // Show the default highest tier on page load
  showTier(tierFilter.value);

  // Change leaderboard when the tier is selected
  tierFilter.addEventListener('change', function() {
    const selectedTier = tierFilter.value;
    fadeOutInLeaderboard(selectedTier);
  });

  function showTier(tierSlug) {
    leaderboardTiers.forEach(tier => {
      if (tier.getAttribute('data-tier') === tierSlug) {
        tier.style.display = 'block'; // Show the matching tier
        reapplyAccordionListeners(tier); // Reapply accordion listeners when the tier is shown
      } else {
        tier.style.display = 'none'; // Hide other tiers
      }
    });
  }

  // Smooth fade out/in effect
  function fadeOutInLeaderboard(tierSlug) {
    const leaderboard = document.getElementById('leaderboard');
    leaderboard.style.opacity = 0; // Fade out
    setTimeout(() => {
      showTier(tierSlug);
      leaderboard.style.opacity = 1; // Fade in
    }, 300);
  }

  // Function to reapply accordion event listeners
  function reapplyAccordionListeners(tier) {
    const accordions = tier.querySelectorAll('.accordion-header');
    accordions.forEach(header => {
      header.removeEventListener('click', toggleAccordion); // Remove any existing event listeners
      header.addEventListener('click', toggleAccordion); // Add event listeners for the accordion headers
    });
  }

  // Toggle accordion content display
  function toggleAccordion() {
    const content = this.nextElementSibling;
    if (content.style.display === 'block') {
      content.style.display = 'none'; // Collapse
    } else {
      content.style.display = 'block'; // Expand
    }
  }
});
